import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const FAQS = [
    {
        q: "En combien de temps vais-je ressentir un soulagement ?",
        a: "Dès les premières minutes : la découpe en U retire la pression du coccyx. La plupart des utilisateurs constatent une nette amélioration après quelques jours d’utilisation régulière.",
    },
    {
        q: "Sur quels sièges peut-on l’utiliser ?",
        a: "Sur n’importe quel siège : chaise de bureau, fauteuil, canapé, siège auto, train ou avion — sa base antidérapante Grip-Lock™ le maintient parfaitement en place.",
    },
    {
        q: "Est-il adapté aux femmes enceintes ?",
        a: "Oui. Il décharge le périnée et le bas du dos, et soulage les tensions lombaires fréquentes pendant la grossesse.",
    },
    {
        q: "Comment entretenir la housse ?",
        a: "La housse respirante se dézippe en quelques secondes et se lave simplement en machine à 30°C.",
    },
    {
        q: "Comment se passe la livraison ?",
        a: "Livraison suivie offerte en France métropolitaine, sous 8 à 12 jours en moyenne. Vous recevez un numéro de suivi dès l’expédition de votre colis.",
    },
    {
        q: "Et si le coussin ne me convient pas ?",
        a: "Vous disposez de 30 nuits d’essai : satisfait ou remboursé, sans discussion. Votre risque est de zéro.",
    },
];

export default function Faq() {
    const [open, setOpen] = useState(0);
    return (
        <section id="faq" className="py-20 lg:py-32 bg-cream">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12">
                <Reveal className="text-center">
                    <p className="text-xs uppercase font-mono tracking-[0.25em] text-sage-mid">Questions fréquentes</p>
                    <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink">
                        Tout ce qu’il faut savoir
                    </h2>
                </Reveal>
                <div className="mt-12 flex flex-col gap-3">
                    {FAQS.map((f, i) => (
                        <Reveal key={i} delay={i * 0.06}>
                            <div
                                data-testid={`faq-item-${i}`}
                                className={`rounded-2xl border transition-colors duration-300 ${
                                    open === i ? "bg-white border-sage/40 shadow-md shadow-sage/10" : "bg-white/60 border-sage/15"
                                }`}
                            >
                                <button
                                    data-testid={`faq-question-${i}`}
                                    onClick={() => setOpen(open === i ? -1 : i)}
                                    className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                                >
                                    <span className="font-semibold text-base text-ink">{f.q}</span>
                                    <Plus
                                        size={18}
                                        className={`shrink-0 text-sage transition-transform duration-300 ${open === i ? "rotate-45" : ""}`}
                                    />
                                </button>
                                <AnimatePresence initial={false}>
                                    {open === i && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                                            className="overflow-hidden"
                                        >
                                            <p className="px-6 pb-6 text-sm lg:text-base text-[#4A5550] leading-relaxed">{f.a}</p>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
